import { Reseller } from "../../components/types";

export const sampleResellers: Reseller[] = [
  {
    id: 1,
    name: "Alpha Communications",
    company: "Alpha Group Ltd.",
    email: "contact@alphacomm.com",
    phone: "+234-801-000-1001",
    registrationDate: "2023-08-15",
    status: "Active",
    totalSales: 620000,
    commission: 62000,
    territory: "Lagos, Port Harcourt",
    level: "Gold",
    lastLogin: "2025-7-19",
  },
  {
    id: 2,
    name: "Beta Marketing",
    company: "Beta Digital Media",
    email: "info@betamarketing.ng",
    phone: "+234-802-000-2002",
    registrationDate: "2023-09-10",
    status: "Active",
    totalSales: 440000,
    commission: 44000,
    territory: "National",
    level: "Silver",
    lastLogin: "2025-6-28",
  },
  {
    id: 3,
    name: "Gamma Outreach",
    company: "Gamma Interactive Ltd.",
    email: "support@gammaoutreach.com",
    phone: "+234-803-000-3003",
    registrationDate: "2023-07-05",
    status: "Inactive",
    totalSales: 37500,
    commission: 3750,
    territory: "South-West",
    level: "Bronze",
    lastLogin: "2025-6-19",
  },
  {
    id: 4,
    name: "Delta Digital",
    company: "Delta Solutions Inc.",
    email: "team@deltadigital.ng",
    phone: "+234-804-000-4004",
    registrationDate: "2023-10-01",
    status: "Active",
    totalSales: 219000,
    commission: 21900,
    territory: "Major Cities",
    level: "Gold",
    lastLogin: "2025-6-18",
  },
];
